<booking-service-mobile *ngIf="isMobile"></booking-service-mobile>
<booking-service-desktop *ngIf="!isMobile"></booking-service-desktop>